import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, ShieldCheckIcon, BotIcon } from 'lucide-react';
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function SystemSection() {
  const phases = [{
    number: '1',
    title: 'ATRACCIÓN PREMIUM',
    icon: SearchIcon,
    body: 'Encontramos a personas que en este momento están buscando exactamente tu servicio en tu ciudad. Coloristas, cortes premium, tratamientos. No buscadores de cupones. Clientes que quieren calidad y están dispuestos a pagarla.'
  }, {
    number: '2',
    title: 'CONVERSIÓN DE CONFIANZA',
    icon: ShieldCheckIcon,
    body: 'Construimos tu presencia digital de alta autoridad. Galería de trabajos que vende sola. Reseñas que generan confianza antes de que el cliente llame. Sistema de reservas online que captura la cita y cobra el depósito automáticamente para eliminar los No-Show.'
  }, {
    number: '3',
    title: 'RETENCIÓN AUTOMATIZADA',
    icon: BotIcon,
    body: 'Nuestra IA le manda WhatsApp automático a tus clientes actuales para que regresen antes de que se vayan a la competencia. Recordatorios de cita. Felicitaciones de cumpleaños con oferta. Reactivación de clientes inactivos.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-[#0a0a0a]" data-id="element-256">
      <div className="max-w-6xl mx-auto" data-id="element-257">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeUpVariants} className="text-center mb-16" data-id="element-258">
          <p className="text-emerald font-semibold tracking-widest uppercase mb-4 text-sm" data-id="element-259">
            Sistema A.C.E.™ Beauty
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold max-w-3xl mx-auto leading-tight" data-id="element-260">
            El Sistema que llena tu agenda con clientes de alto valor todos los
            días.
          </h2>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-261">
          {phases.map(phase => {
          const Icon = phase.icon;
          return <motion.div key={phase.number} variants={fadeUpVariants} className="relative bg-surface p-8 rounded-xl border border-gold/20 flex flex-col h-full" data-id="element-262">
                <div className="flex items-center mb-6" data-id="element-263">
                  <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center mr-4" data-id="element-264">
                    <Icon className="w-6 h-6 text-gold" data-id="element-265" />
                  </div>
                  <div data-id="element-266">
                    <span className="text-gold text-sm font-bold tracking-wider" data-id="element-267">
                      FASE {phase.number}
                    </span>
                    <h3 className="text-lg font-bold text-white mt-1" data-id="element-268">
                      {phase.title}
                    </h3>
                  </div>
                </div>
                <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-269">
                  {phase.body}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}